import { useEffect, useRef } from "react";
import gsap from "gsap";

export const CustomCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    if (
      window.matchMedia("(hover: none)").matches ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      return undefined;
    }
    const dot = dotRef.current;
    const ring = ringRef.current;
    const dotX = gsap.quickTo(dot, "x", { duration: 0.08, ease: "power2.out" });
    const dotY = gsap.quickTo(dot, "y", { duration: 0.08, ease: "power2.out" });
    const ringX = gsap.quickTo(ring, "x", { duration: 0.4, ease: "power3.out" });
    const ringY = gsap.quickTo(ring, "y", { duration: 0.4, ease: "power3.out" });

    let lastX = 0;
    let lastY = 0;
    const updateTheme = (el) => {
      const dark = Boolean(el && el.closest && el.closest('[data-dark="true"]'));
      dot.classList.toggle("on-dark", dark);
      ring.classList.toggle("on-dark", dark);
    };

    const onMove = (e) => {
      lastX = e.clientX;
      lastY = e.clientY;
      dotX(e.clientX);
      dotY(e.clientY);
      ringX(e.clientX);
      ringY(e.clientY);
      updateTheme(e.target);
    };
    const onOver = (e) => {
      const interactive = e.target.closest(
        "a, button, input, textarea, select, [data-cursor='pointer']"
      );
      ring.classList.toggle("is-hovering", Boolean(interactive));
    };
    const onScroll = () => {
      updateTheme(document.elementFromPoint(lastX, lastY));
    };
    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mouseover", onOver, { passive: true });
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <>
      <div ref={dotRef} className="cursor-dot" aria-hidden="true" />
      <div ref={ringRef} className="cursor-ring" aria-hidden="true" />
    </>
  );
};
